export default __webpack_public_path__ + "static/media/excel.df79cccb.PNG";